import { defineRecipe } from '@chakra-ui/react';

export const headingRecipe = defineRecipe({
    variants: {
        size: {
            apartmentTile: {
                lineHeight: 1.25,
                fontSize: {
                    base: 'md',
                    md: 'xl',
                },
            },
            '2xs': {
                textStyle: 'sm',
            },
            xs: {
                textStyle: 'lg',
            },
            sm: {
                textStyle: {
                    base: 'lg',
                    md: 'xl',
                },
            },
            md: {
                textStyle: {
                    base: 'xl',
                    md: '2xl',
                },
            },
            lg: {
                textStyle: {
                    base: '2xl',
                    md: '3xl',
                },
            },
            xl: {
                textStyle: {
                    base: '3xl',
                    md: '4xl',
                },
            },
            '2xl': {
                textStyle: {
                    base: '4xl',
                    md: '5xl',
                },
            },
            '3xl': {
                textStyle: {
                    base: '5xl',
                    md: '6xl',
                },
            },
            '4xl': {
                textStyle: {
                    base: '6xl',
                    md: '7xl',
                },
            },
            // '5xl': {},
            // '6xl': {},
            // '7xl': {},
        },
    },
});
